// Credit: https://github.com/jaredmcqueen/analytics/blob/master/lib/UbuntuMono.js

import * as THREE from 'three'

const UbuntuMono = function (path) {
  let texture = new THREE.TextureLoader().load(path)
  texture.flipY = false
  texture.repeat.set(1, 1)

  return {
    texture: texture,
    // char  x  y  w  h  xoffset  yoffset
    '0': [ 1016, 972, 4, 4, -1.500, 1.500 ],
    '8': [ 1016, 968, 4, 4, -1.500, 1.500 ],
    '9': [ 1016, 964, 4, 4, -1.500, 1.500 ],
    '13': [ 1016, 960, 4, 4, -1.500, 1.500 ],
    '29': [ 1016, 956, 4, 4, -1.500, 1.500 ],
    '32': [ 1016, 952, 4, 4, -1.500, 1.500 ],
    '33': [ 719, 0, 25, 105, 27.625, 101.188 ],
    '34': [ 745, 966, 42, 44, 19.250, 110.875 ],
    '35': [ 745, 631, 75, 103, 2.875, 101.188 ],
    '36': [ 271, 0, 67, 131, 7.188, 113.125 ],
    '37': [ 458, 0, 78, 107, 1.375, 103.313 ],
    '38': [ 609, 421, 75, 107, 3.500, 103.500 ],
    '39': [ 787, 966, 17, 47, 31.813, 110.875 ],
    '40': [ 538, 780, 48, 143, 16.688, 114.438 ],
    '41': [ 538, 637, 48, 143, 16.688, 114.438 ],
    '42': [ 678, 961, 66, 63, 7.688, 101.188 ],
    '43': [ 734, 107, 69, 74, 5.875, 79.125 ],
    '44': [ 771, 27, 36, 49, 22.438, 23.875 ],
    '45': [ 538, 1005, 39, 16, 21.063, 48.688 ],
    '46': [ 842, 990, 27, 28, 27.000, 24.188 ],
    '47': [ 209, 0, 62, 143, 9.563, 114.125 ],
    '48': [ 609, 751, 69, 108, 5.875, 103.500 ],
    '49': [ 664, 210, 62, 103, 10.500, 101.188 ],
    '50': [ 884, 313, 66, 106, 7.688, 103.500 ],
    '51': [ 751, 313, 65, 108, 7.938, 103.500 ],
    '52': [ 944, 734, 73, 103, 4.313, 101.188 ],
    '53': [ 458, 726, 64, 105, 9.063, 101.188 ],
    '54': [ 891, 421, 67, 106, 7.188, 101.563 ],
    '55': [ 538, 534, 67, 103, 8.625, 101.250 ],
    '56': [ 609, 859, 68, 108, 6.688, 103.500 ],
    '57': [ 678, 855, 67, 106, 6.688, 103.438 ],
    '58': [ 744, 0, 27, 80, 27.000, 76.188 ],
    '59': [ 988, 107, 36, 101, 18.625, 76.188 ],
    '60': [ 877, 955, 69, 68, 6.375, 74.625 ],
    '61': [ 609, 967, 69, 46, 5.875, 64.813 ],
    '62': [ 947, 952, 69, 68, 6.375, 74.625 ],
    '63': [ 536, 0, 55, 107, 13.313, 103.438 ],
    '64': [ 75, 0, 72, 127, 4.938, 103.438 ],
    '65': [ 458, 107, 81, 103, -0.063, 101.188 ],
    '66': [ 684, 313, 67, 105, 7.188, 102.000 ],
    '67': [ 877, 847, 70, 108, 5.875, 103.500 ],
    '68': [ 684, 421, 69, 105, 7.188, 102.188 ],
    '69': [ 539, 210, 60, 103, 13.125, 101.188 ],
    '70': [ 963, 631, 60, 103, 13.125, 101.188 ],
    '71': [ 609, 643, 69, 108, 5.875, 103.500 ],
    '72': [ 895, 528, 70, 103, 5.750, 101.188 ],
    '73': [ 966, 528, 54, 103, 12.813, 101.188 ],
    '74': [ 458, 831, 62, 105, 7.188, 101.188 ],
    '75': [ 820, 631, 72, 103, 8.813, 101.188 ],
    '76': [ 601, 210, 63, 103, 13.125, 101.188 ],
    '77': [ 825, 528, 70, 103, 5.438, 101.188 ],
    '78': [ 458, 416, 66, 103, 7.375, 101.188 ],
    '79': [ 609, 313, 75, 108, 3.188, 103.500 ],
    '80': [ 458, 622, 65, 104, 10.250, 102.000 ],
    '81': [ 0, 0, 75, 132, 3.188, 103.313 ],
    '82': [ 822, 421, 69, 104, 7.375, 102.000 ],
    '83': [ 678, 747, 66, 108, 7.313, 103.500 ],
    '84': [ 892, 631, 71, 103, 4.750, 101.188 ],
    '85': [ 753, 421, 69, 105, 6.250, 101.250 ],
    '86': [ 458, 313, 80, 103, 0.563, 101.188 ],
    '87': [ 754, 528, 71, 103, 5.438, 101.188 ],
    '88': [ 678, 528, 76, 103, 2.500, 101.188 ],
    '89': [ 458, 210, 80, 103, 0.563, 101.188 ],
    '90': [ 816, 313, 68, 103, 7.188, 101.188 ],
    '91': [ 398, 143, 42, 143, 21.500, 114.125 ],
    '92': [ 147, 0, 62, 143, 9.750, 114.125 ],
    '93': [ 398, 286, 42, 143, 17.438, 114.125 ],
    '94': [ 648, 0, 71, 58, 4.938, 101.188 ],
    '95': [ 807, 27, 81, 15, -0.188, -13.813 ],
    '96': [ 811, 990, 31, 32, 24.688, 113.125 ],
    '97': [ 607, 107, 64, 82, 7.813, 78.000 ],
    '98': [ 745, 734, 66, 117, 9.938, 113.125 ],
    '99': [ 539, 107, 68, 82, 6.375, 78.063 ],
    '100': [ 811, 734, 66, 117, 4.938, 113.125 ],
    '101': [ 947, 210, 70, 82, 4.938, 78.000 ],
    '102': [ 538, 313, 71, 115, 8.625, 113.125 ],
    '103': [ 958, 421, 66, 107, 4.938, 55.000 ],
    '104': [ 745, 851, 62, 115, 9.938, 113.125 ],
    '105': [ 880, 735, 63, 112, 7.188, 109.438 ],
    '106': [ 811, 851, 54, 139, 9.938, 109.375 ],
    '107': [ 609, 528, 69, 115, 9.938, 113.188 ],
    '108': [ 679, 631, 66, 116, 7.188, 112.313 ],
    '109': [ 875, 210, 72, 80, 5.125, 77.813 ],
    '110': [ 865, 107, 62, 80, 9.938, 77.875 ],
    '111': [ 538, 923, 71, 82, 4.938, 78.063 ],
    '112': [ 950, 313, 66, 106, 9.938, 50.0 ],
    '113': [ 538, 428, 66, 106, 4.938, 77.875 ],
    '114': [ 591, 0, 57, 80, 15.750, 77.875 ],
    '115': [ 671, 107, 63, 82, 9.063, 78.000 ],
    '116': [ 458, 519, 66, 103, 8.625, 99.500 ],
    '117': [ 803, 107, 62, 80, 9.438, 76.250 ],
    '118': [ 801, 210, 74, 78, 3.313, 76.250 ],
    '119': [ 458, 936, 78, 78, 1.500, 76.250 ],
    '120': [ 726, 210, 75, 78, 3.125, 76.250 ],
    '121': [ 947, 847, 72, 105, 4.250, 55.000 ],
    '122': [ 927, 107, 61, 78, 10.250, 76.250 ],
    '123': [ 398, 0, 60, 143, 11.188, 114.125 ],
    '124': [ 586, 780, 16, 143, 32.625, 114.063 ],
    '125': [ 338, 0, 60, 143, 10.250, 114.125 ],
    '126': [ 771, 0, 72, 27, 4.438, 55.813 ]
  }
}

export default UbuntuMono



// WEBPACK FOOTER //
// ./src/libs/geometry/text/fonts/UbuntuMono.js